<script setup lang="ts">
import { useCmsTranslations } from "@shopware/composables";
import { defu } from "defu";

defineProps<{
  total: number;
  current: number;
}>();

type Translations = {
  listing: {
    previous: string;
    next: string;
  };
};

let translations: Translations = {
  listing: {
    previous: "Previous",
    next: "Next",
  },
};

translations = defu(useCmsTranslations(), translations) as Translations;

defineEmits<(e: "changePage", page: number) => void>();
</script>
<template>
  <nav
    class="relative z-0 inline-flex rounded-md shadow-sm"
    aria-label="Pagination"
  >
    <button
      v-if="current - 1 >= 1"
      class="w-11 h-11 bg-cust_cream border border-solid border-cust_black flex items-center justify-center rounded-lg mx-2"
      @click="$emit('changePage', current - 1)"
    >
      <i class="fa-solid fa-angle-left"></i>
    </button>
    <button
      v-if="current > 2"
      class="w-11 h-11 bg-cust_cream border border-solid border-cust_black flex items-center justify-center rounded-lg mx-2"
      @click="$emit('changePage', 1)"
    >
      <i class="fa-solid fa-angles-left"></i>
    </button>

    <button
      aria-current="page"
      class="w-11 h-11 border border-solid border-cust_green bg-cust_green flex items-center justify-center rounded-lg text-white hover:text-white mx-2"
      :class="[
        current - 1 >= 1 ? '' : 'bg-cust_green',
        total == current ? 'bg-cust_green' : '',
      ]"
    >
      <span class="sr-only">Page </span>{{ current }}
    </button>

    <button
      v-if="total - current > 1"
      class="w-11 h-11 bg-cust_cream border border-solid border-cust_black flex items-center justify-center rounded-lg mx-2"
      @click="$emit('changePage', total)"
    >
      <i class="fa-solid fa-angles-right"></i>
    </button>
    <button
      v-if="total > current"
      class="w-11 h-11 bg-cust_cream border border-solid border-cust_black flex items-center justify-center rounded-lg mx-2"
      @click="$emit('changePage', current + 1)"
    >
      <i class="fa-solid fa-angle-right"></i>
    </button>
    
    <p class="text-base lg:text-lg whitespace-nowrap pt-2">{{$t('plubel.listing.of')}} {{ total }}</p>
  </nav>
</template>
